module.exports = ".example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 70%;\n}\n\n.mat-card-content{\n        min-height: 115px;\n}\n\n.example-card {\nmargin-bottom: 15px;\nmargin-left: 15px;\n}\n\n.example-header-image {\n  background-image: url('https://material.angular.io/assets/img/examples/shiba1.jpg');\n  background-size: cover;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/projects/projects/projects.component.css
// module id = ./src/app/pages/projects/projects/projects.component.css
// module chunks = main